module.exports = __webpack_public_path__ + "static/media/hero-comp.ee174970.png";